import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
const HomeView = () => import('@/views/HomeView.vue')
const TheAbout = () => import('@/views/TheAbout.vue')
const TheCross = () => import('@/views/TheCross.vue')
const TheCate = () => import('@/views/TheCate.vue')
import NotFound from '@/components/NotFound.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home/', name: 'HomeView', component: HomeView },
    {
      path: '/:cate',
      name: 'TheCate',
      component: TheCate,
      props: true,
      meta: { requiresAuth: true }
    },
    { path: '/about', name: 'TheAbout', component: TheAbout },
    {
      path: '/:cate/:uniqId',
      name: 'TheCross',
      component: TheCross,
      props: true,
      // props: (route) => ({
      //   cate: route.params.cate,
      // }),
      meta: { requiresAuth: true }
    },
    { path: '/:notFound(.*)', component: NotFound }
  ]
})

router.beforeEach((to, _, next) => {
  if (to.meta.requiresAuth && !store.getters.isAuth) {
    next('/home')
  } else next()
})

export default router
